import ServiceTemplate from './ServiceTemplate';

const ErectileDysfunction = () => {
  const data = {
    title: 'Erectile Dysfunction (ED)',
    tagline: 'Regain Confidence. Restore Performance.',
    description: 'Erectile Dysfunction (ED) is one of the most common mens health concerns, affecting millions of men. It is defined as the inability to achieve or maintain an erection firm enough for sexual activity.',
    causesTitle: 'What Causes ED?',
    causes: [
      'Reduced blood flow',
      'Low testosterone',
      'Diabetes or high blood pressure',
      'Stress or anxiety',
      'Medication side effects',
    ],
    symptoms: [
      'Difficulty achieving an erection',
      'Difficulty maintaining an erection',
      'Reduced sexual desire',
    ],
    treatments: [
      'Oral medications',
      'Hormone optimization',
      'Shockwave therapy',
      'Lifestyle improvements',
    ],
    faqs: [
      { q: 'How common is erectile dysfunction?', a: 'ED is very common, affecting approximately 30 million men in the United States. The likelihood increases with age, but ED can occur at any age and is often treatable.' },
      { q: 'What should I expect at my first appointment?', a: 'Your first visit will include a confidential discussion of your symptoms, medical history review, and possibly lab work. Dr. Havkin will explain your options and create a personalized treatment plan.' },
      { q: 'Are ED treatments covered by insurance?', a: 'Coverage varies by plan. Our office can help verify your insurance benefits and discuss payment options during your consultation.' },
    ],
    cta: 'Book a confidential consultation today.',
    seoTitle: 'Erectile Dysfunction (ED) Treatment Melbourne FL',
    seoDescription: 'Expert erectile dysfunction treatment in Melbourne, FL. Dr. Havkin offers oral medications, hormone therapy, shockwave therapy & more. Call (321) 500-4545.',
    seoKeywords: 'erectile dysfunction treatment Melbourne FL, ED doctor, ED therapy, shockwave therapy ED, urologist ED treatment',
    seoCanonical: '/services/erectile-dysfunction',
  };

  return <ServiceTemplate {...data} />;
};

export default ErectileDysfunction;
